// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"fb0473f6","455":"78ab6d92"}[chunkId] + ".chunk.js";
};